import * as React from "react";
import ContainerHybrid from "./ContainerHybrid";
import type { TypeBoxProps } from "@sproutsocial/seeds-react-box";

/**
 * Container component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
const Container = React.forwardRef<HTMLDivElement, TypeBoxProps>(
  (props, ref) => {
    return <ContainerHybrid {...props} ref={ref} />;
  }
);

Container.displayName = "Container";

export default Container;
